import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule,registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule, HttpClient } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { StompRService } from "@stomp/ng2-stompjs";

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from "src/environments/environment";

//기본 템플릿에서 제공하는 컴포넌트
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { NavigationComponent } from './layouts/header-navigation/navigation.component';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { BreadcrumbComponent } from './layouts/breadcrumb/breadcrumb.component';
import { SpinnerComponent } from './layouts/spinner.component';
import { LoadingSpinModalComponent } from "./layouts/loading.spin.modal/loading.spin.modal.component";
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
  minScrollbarLength: 20
};

// import { GoogleChartsModule } from 'angular-google-charts';
import { CalendarModule,DateAdapter, CalendarDateFormatter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import localeKo from '@angular/common/locales/ko';
registerLocaleData(localeKo);

import { SidebarCarListComponent } from "./layouts/sidebar.car.list/sidebar.car.list.component";
import { SidebarExtCarListComponent } from "./layouts/sidebar.ext.car.list/sidebar.ext.car.list.component";

//common service
import {
    FvmsAlertService
    ,FvmsApiAuthGuard
    ,FvmsApiReverseAuthGuard
    ,FvmsApiAuthService
    ,FvmsApiBaseService
    ,FvmsApiCompanyService
    ,FvmsApiDtgAddrService
    ,FvmsApiDtgCarService
    ,FvmsApiDtgDangerDriveService
    ,FvmsApiDtgDashboardService
    ,FvmsApiDtgDeviceService
    ,FvmsApiDtgDownloadService
    ,FvmsApiDtgDriverService
    ,FvmsApiDtgGeoFenceService
    ,FvmsApiDtgInstallService
    ,FvmsApiDtgReportCarService
    ,FvmsApiDtgReportDangerService
    ,FvmsApiDtgReportRestService
    // ,FvmsApiDtgReportUserService
    ,FvmsApiDtgReportSafeDrivingService
    ,FvmsApiDtgDriveSafeEcoService
    ,FvmsApiDtgTeamService
    ,FvmsApiDtgUserService
    ,FvmsApiDtgWsProcessorService
    ,FvmsApiHttpInterceptor
    ,FvmsApiNoticeService
    ,FvmsCommonService
    ,FvmsUtilService
    ,FvmsExcelService
    ,I18n
    ,I18nDatePicker
    ,FvmsMapApiProvidor
    ,FvmsMapApiServiceGoogle
    ,FvmsMapApiServiceKakao
    ,FvmsMainCarService
    ,FvmsDtgDriveScheduleRestService
    ,FvmsDtgCarDriveHisService
} from "./shared/service";

//common component
import {
    CompanySelectorComponent
    ,CompanySelectorTreeNodeComponent
    ,DateSelectorComponent
    ,IconAlertComponent
    ,IconGpsComponent
    ,IconNetworkComponent
    ,IconPowerComponent
    ,IconCarBusComponent
    ,IconCarSedanComponent
    ,IconCarTruckComponent
    ,IconLogoCrestinvolvementComponent
    ,IconLogoTitleComponent
    ,ListPagingComponent
    ,ModalAddrSearchComponent
    ,UserInfoComponent
    ,YmdSelectorComponent
    ,CarRealtimeCardComponent
    ,ModalAlramComponent
} from "./shared/components";

//common filter (pipe)
import {
    FilterCarStatus
    ,FilterCarStatusTrans
    ,FilterCarStatusTimeLimit
    ,FilterCarTeam
    ,FilterCarSearch
    ,FilterCompanyName
    ,FilterDateTime
    ,FilterDateTimeMax
    ,FilterSecToTime
    ,FilterDateDiff
    ,FilterDateDiffHuman
    ,FilterLeftPadd
    ,FilterLimitLevel
    ,FilterDist
    ,FilterGeoFenceExist
    ,FilterPacket
    ,FilterParentMenuId
    ,SortByPipe
    ,FilterVolt
} from "./shared/filter";

//fvms component
import {
    EulaModalComponent
    ,AuthLoginComponent
    ,AuthExtLoginComponent
    ,AuthExtErrE401Component
    ,PrivacyModalComponent
    ,AuthResetPasswordModalComponent
    ,NoticeDetailPopupComponent
    ,NoticeListPopupComponent
    ,FvmsDownloadEtasMainComponent
    ,InstallMainComponent
} from "./fvms";

//dtg component
import {
    DtgAnalyticsDashboardComponent
    ,DtgAnalyticsDriveSafeSummaryComponent
    ,DtgAnalyticsDriveSafeEcoComponent //Deprecated
    ,DtgAnalyticsDriveSafeSafetyComponent
    ,DtgAnalyticsDriveDangerStopHighRpmListComponent
    ,DtgAnalyticsDriveDangerStopHighRpmMainComponent
    ,DtgAnalyticsDriveDangerStopHighRpmDetailComponent

    // ,DtgCarLastListComponent
    ,DtgCarLastTripListComponent
    ,DtgCarLastTotalComponent
    ,DtgCarLastListMapComponent

    ,DtgCarExtLastMapComponent
    ,DtgCarExtDriveHistComponent

    ,DtgConfigSystemComponent
    ,DtgDownloadCalendarComponent

    ,DtgDownloadEtasRequestMainComponent
    ,DtgDownloadEtasRequestListComponent

    ,DtgManageCarMainComponent
    ,DtgManageCarListComponent
    ,DtgManageCarFormComponent
    ,DtgManageCarSearchComponent

    ,DtgManageCarExtAcceptMainComponent
    ,DtgManageCarExtAcceptListComponent
    ,DtgManageCarExtAcceptModalSearchCompanyComponent

    ,DtgManageCarExtMainMainComponent
    ,DtgManageCarExtMainListComponent
    ,DtgManageCarExtMainFormComponent

    ,DtgManageCompanyMainComponent
    ,DtgManageCompanyTreeComponent
    ,DtgManageCompanyFormComponent
    ,DtgManageCompanyListComponent
    ,DtgManageCompanySearchComponent
    ,DtgManageCompanyModalDeleteComponent

    ,DtgManageDangerDriveRuleMainComponent
    ,DtgManageDangerDriveRuleListComponent

    ,DtgManageDriverMainComponent
    ,DtgManageDriverListComponent
    ,DtgManageDriverFormComponent
    ,DtgManageDriverSearchComponent

    ,DtgManageEtasCarMainComponent
    ,DtgManageEtasCarListComponent
    ,DtgManageEtasCarFormComponent

    ,DtgManageEtasFileMainComponent
    ,DtgManageEtasFileRequestComponent

    ,GeofenceConfMainComponent
    ,GeofenceConfListComponent
    ,GeofenceConfFormComponent
    ,GeofenceConfSearchComponent
    ,DtgGeofenceCarMainComponent
    ,DtgGeofenceCarListComponent
    ,GeofenceRouteListComponent
    ,GeofenceRouteMainComponent

    ,DtgManageNoticeMainComponent
    ,DtgManageNoticeListComponent
    ,DtgManageNoticeFormComponent

    ,DtgManageTeamMainComponent
    ,DtgManageTeamListComponent
    ,DtgManageTeamFormComponent
    ,DtgManageTeamSearchComponent

    ,DtgManageUserMainComponent
    ,DtgManageUserListComponent
    ,DtgManageUserFormComponent

    ,DtgManageMainComponent

    ,DtgNoticeMainComponent
    ,DtgNoticeListComponent
    ,DtgNoticeFormComponent

    ,DtgManageScheduleDriveMainComponent
    ,DtgManageScheduleDriveListComponent
    ,DtgManageScheduleDriveFormComponent
    ,DtgManageScheduleDriveRegistComponent
    ,DtgManageScheduleDriveDeleteComponent

    ,DtgPacketRealtimeComponent

    ,DtgReportCarAllComponent
    ,DtgReportCarDetailComponent
    ,DtgReportCarTripDetailComponent
    ,DtgReportCarTripDetailListComponent
    ,DtgReportCarDaySummaryComponent

    ,DtgReportCarMonthMainComponent
    ,DtgReportCarMonthDailyComponent
    ,DtgReportCarMonthSummaryComponent

    ,DtgReportCarTemperMainComponent
    ,DtgReportCarTemperDailyComponent
    ,DtgReportCarTemperSummaryComponent
    ,DtgReportCarTemperDetailComponent

    ,ReportGeofenceHisListComponent
    ,ReportGeofenceHisMainComponent
    ,ReportGeofenceHisPositionComponent

    ,DtgReportRestDayScheduleComponent
    ,DtgReportRestDriveScheduleAllComponent
    ,DtgReportDangerDayMainComponent
    ,DtgReportDangerDayDetailComponent


    // ,DtgReportUserAllComponent
    // ,DtgReportUserSafeDetailComponent
    // ,DtgReportUserTripDetailComponent
    // ,DtgReportUserPersonalComponent
    ,DtgTestT01Component
    ,DtgTestT02Component
    ,DtgTestT03Component
    ,DtgAnalyticsDriveCarbonListComponent
    ,DtgAnalyticsDriveCarbonMainComponent
} from "./dtg";


@NgModule({
    declarations: [
        AppComponent
        ,SpinnerComponent
        ,LoadingSpinModalComponent
        ,FullComponent
        ,BlankComponent
        ,NavigationComponent
        ,BreadcrumbComponent
        ,SidebarComponent
        ,SidebarCarListComponent
        ,SidebarExtCarListComponent

        ,CompanySelectorComponent
        ,CompanySelectorTreeNodeComponent
        ,DateSelectorComponent
        ,IconAlertComponent
        ,IconGpsComponent
        ,IconNetworkComponent
        ,IconPowerComponent
        ,IconCarBusComponent
        ,IconCarSedanComponent
        ,IconCarTruckComponent
        ,IconLogoCrestinvolvementComponent
        ,IconLogoTitleComponent
        ,ListPagingComponent
        ,ModalAddrSearchComponent
        ,UserInfoComponent
        ,YmdSelectorComponent
        ,CarRealtimeCardComponent

        ,FilterCarStatus
        ,FilterCarStatusTrans
        ,FilterCarStatusTimeLimit
        ,FilterCarTeam
        ,FilterCarSearch
        ,FilterCompanyName
        ,FilterDateTime
        ,FilterDateTimeMax
        ,FilterSecToTime
        ,FilterDateDiff
        ,FilterDateDiffHuman
        ,FilterLeftPadd
        ,FilterLimitLevel
        ,FilterDist
        ,FilterGeoFenceExist
        ,FilterPacket
        ,FilterParentMenuId
        ,SortByPipe
        ,FilterVolt

        ,EulaModalComponent
        ,AuthLoginComponent
        ,AuthExtLoginComponent
        ,AuthExtErrE401Component
        ,PrivacyModalComponent
        ,AuthResetPasswordModalComponent
        ,NoticeDetailPopupComponent
        ,NoticeListPopupComponent
        ,FvmsDownloadEtasMainComponent
        ,InstallMainComponent

        ,DtgAnalyticsDashboardComponent
        ,DtgAnalyticsDriveSafeSummaryComponent
        ,DtgAnalyticsDriveSafeEcoComponent //Deprecated
        ,DtgAnalyticsDriveSafeSafetyComponent
        ,DtgAnalyticsDriveDangerStopHighRpmListComponent
        ,DtgAnalyticsDriveDangerStopHighRpmMainComponent
        ,DtgAnalyticsDriveDangerStopHighRpmDetailComponent

        // ,DtgCarLastListComponent
        ,DtgCarLastTripListComponent
        ,DtgCarLastTotalComponent
        ,DtgCarLastListMapComponent

        ,DtgCarExtLastMapComponent
        ,DtgCarExtDriveHistComponent

        ,DtgConfigSystemComponent
        ,DtgDownloadCalendarComponent

        ,DtgDownloadEtasRequestMainComponent
        ,DtgDownloadEtasRequestListComponent

        ,DtgManageCarMainComponent
        ,DtgManageCarListComponent
        ,DtgManageCarFormComponent
        ,DtgManageCarSearchComponent

        ,DtgManageCarExtAcceptMainComponent
        ,DtgManageCarExtAcceptListComponent
        ,DtgManageCarExtAcceptModalSearchCompanyComponent

        ,DtgManageCarExtMainMainComponent
        ,DtgManageCarExtMainListComponent
        ,DtgManageCarExtMainFormComponent

        ,DtgManageCompanyMainComponent
        ,DtgManageCompanyTreeComponent
        ,DtgManageCompanyFormComponent
        ,DtgManageCompanyListComponent
        ,DtgManageCompanySearchComponent
        ,DtgManageCompanyModalDeleteComponent

        ,DtgManageDangerDriveRuleMainComponent
        ,DtgManageDangerDriveRuleListComponent

        ,DtgManageDriverMainComponent
        ,DtgManageDriverListComponent
        ,DtgManageDriverFormComponent
        ,DtgManageDriverSearchComponent

        ,DtgManageEtasCarMainComponent
        ,DtgManageEtasCarListComponent
        ,DtgManageEtasCarFormComponent

        ,DtgManageEtasFileMainComponent
        ,DtgManageEtasFileRequestComponent

        ,GeofenceConfMainComponent
        ,GeofenceConfListComponent
        ,GeofenceConfFormComponent
        ,GeofenceConfSearchComponent
        ,DtgGeofenceCarMainComponent
        ,DtgGeofenceCarListComponent
        ,GeofenceRouteListComponent
        ,GeofenceRouteMainComponent

        ,DtgManageNoticeMainComponent
        ,DtgManageNoticeListComponent
        ,DtgManageNoticeFormComponent

        ,DtgManageTeamMainComponent
        ,DtgManageTeamListComponent
        ,DtgManageTeamFormComponent
        ,DtgManageTeamSearchComponent

        ,DtgManageUserMainComponent
        ,DtgManageUserListComponent
        ,DtgManageUserFormComponent

        ,DtgManageMainComponent

        ,DtgNoticeMainComponent
        ,DtgNoticeListComponent
        ,DtgNoticeFormComponent

        ,DtgManageScheduleDriveMainComponent
        ,DtgManageScheduleDriveListComponent
        ,DtgManageScheduleDriveFormComponent
        ,DtgManageScheduleDriveRegistComponent
        ,DtgManageScheduleDriveDeleteComponent

        ,DtgPacketRealtimeComponent

        ,DtgReportCarAllComponent
        ,DtgReportCarDetailComponent
        ,DtgReportCarTripDetailComponent
        ,DtgReportCarTripDetailListComponent
        ,DtgReportCarDaySummaryComponent

        ,DtgReportCarMonthMainComponent
        ,DtgReportCarMonthDailyComponent
        ,DtgReportCarMonthSummaryComponent

        ,DtgReportCarTemperMainComponent
        ,DtgReportCarTemperDailyComponent
        ,DtgReportCarTemperSummaryComponent
        ,DtgReportCarTemperDetailComponent

        ,ReportGeofenceHisListComponent
        ,ReportGeofenceHisMainComponent
        ,ReportGeofenceHisPositionComponent

        ,DtgReportRestDayScheduleComponent
        ,DtgReportRestDriveScheduleAllComponent
        ,DtgReportDangerDayMainComponent
        ,DtgReportDangerDayDetailComponent


        // ,DtgReportUserAllComponent
        // ,DtgReportUserPersonalComponent
        // ,DtgReportUserSafeDetailComponent
        // ,DtgReportUserTripDetailComponent
        ,DtgTestT01Component
        ,DtgTestT02Component
        ,DtgTestT03Component
        ,ModalAlramComponent
        ,DtgAnalyticsDriveCarbonListComponent
        ,DtgAnalyticsDriveCarbonMainComponent
    ]
    ,imports: [
        CommonModule
        ,BrowserModule
        ,BrowserAnimationsModule
        ,FormsModule
        ,ReactiveFormsModule
        ,HttpClientModule
        ,HttpClientJsonpModule
        ,NgbModule
        ,RouterModule.forRoot(Approutes)
        ,PerfectScrollbarModule
        // ,GoogleChartsModule.forRoot({mapsApiKey:environment.google.map.key})
        ,CalendarModule.forRoot({
          provide : DateAdapter
          ,useFactory : adapterFactory
        })
        ,NgxGoogleAnalyticsModule.forRoot(environment.google.analytics.id)
    ]
    ,exports: [
        DateSelectorComponent
    ]
    ,entryComponents:[
        LoadingSpinModalComponent
    ]
    ,providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG
            ,useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
        ,I18n
        ,I18nDatePicker
        ,StompRService
        ,FvmsAlertService
        ,FvmsApiBaseService
        ,FvmsApiAuthGuard
        ,FvmsApiReverseAuthGuard
        ,FvmsApiAuthService
        ,FvmsApiCompanyService
        ,FvmsApiDtgAddrService
        ,FvmsApiDtgCarService
        ,FvmsApiDtgDangerDriveService
        ,FvmsApiDtgDashboardService
        ,FvmsApiDtgDeviceService
        ,FvmsApiDtgDownloadService
        ,FvmsApiDtgDriverService
        ,FvmsApiDtgGeoFenceService
        ,FvmsApiDtgInstallService
        ,FvmsApiDtgReportCarService
        ,FvmsApiDtgReportDangerService
        ,FvmsApiDtgReportRestService
        // ,FvmsApiDtgReportUserService
        ,FvmsApiDtgReportSafeDrivingService
        ,FvmsApiDtgDriveSafeEcoService
        ,FvmsApiDtgTeamService
        ,FvmsApiDtgUserService
        ,FvmsApiDtgWsProcessorService
        ,FvmsApiNoticeService
        ,FvmsCommonService
        ,FvmsUtilService
        ,FvmsExcelService
        ,FvmsMapApiProvidor
        ,FvmsMapApiServiceGoogle
        ,FvmsMapApiServiceKakao
        ,FvmsMainCarService
        ,FvmsDtgDriveScheduleRestService
        ,FvmsDtgCarDriveHisService
        ,{
            provide:HTTP_INTERCEPTORS
            ,useClass:FvmsApiHttpInterceptor
            ,multi:true
        }
    ]
    ,bootstrap: [AppComponent]
})
export class AppModule {}
